import React from 'react';
import * as PropTypes from 'prop-types';
import clsx from 'clsx';

export const StepContent = (props) => {
  const {
    className,
    ...other
  } = props;

  return (
    <div className={clsx(
      "stepContent d-flex flex-col border-box flex-auto overflow-y-auto overflow-x-hidden p-3 p-sm-none",
      className
    )} {...other}>
    </div>
  );
};

StepContent.propTypes = {
  index: PropTypes.number,
  className: PropTypes.string,
};

export default StepContent;
